import { render, staticRenderFns } from "./WithdrawView.vue?vue&type=template&id=012846cc&"
import script from "./WithdrawView.vue?vue&type=script&lang=js&"
export * from "./WithdrawView.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawView.vue?vue&type=style&index=0&id=012846cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports